import { C, P0, R, S, abs, fillAt, max, rotPts, sq } from '../../geometry';

export const layers = {
  name: 'Layers',
  colors: ['#D6409F', '#3E63DD'],
  draw(m, t) {
    let ang = 45 + 6 * S(t * 0.8),
      d = 7 + 0.6 * S(t * 1.6),
      tw = 5 + S(t * 1.2),
      s = 16,
      pose = P0();
    if (m === 'happy') {
      d = 8 + 4 * abs(S(t * 7));
      ang = 45 + 20 * S(t * 5);
      tw = 8;
      pose.ty = -2 * abs(S(t * 6));
    }
    // Thinking: the cards keep circling behind the front one, like a deck being shuffled.
    if (m === 'thinking') {
      ang = t * 140;
      d = 8;
      tw = 10 * S(t * 2);
    }
    if (m === 'talking') d = 6 + 4 * max(0, S(t * 10));
    if (m === 'surprised') {
      d = 12;
      s = 17;
      tw = 12;
      pose.ty = -2;
    }
    if (m === 'paused') {
      d = 3.5;
      ang = 35;
      tw = -4;
      pose.ty = 2;
    }
    const card = (k) => {
      const cx = 50 + k * d * C(ang * R),
        cy = 52 + k * d * S(ang * R);
      return rotPts(sq(cx, cy, s, s, 4.2, 24), cx, cy, k * tw);
    };
    return {
      strokes: [
        { c: 'a', pts: card(2), n: 28 },
        { c: 'b', pts: card(1), n: 28 },
        { c: 'a', pts: card(0), n: 28 },
      ],
      eyes: { x: 50, y: 52 },
      pose,
    };
  },
  eyesOn: 'a',
  solid: (f) => fillAt(f, 2),
};
